import { api } from "./client";

export const emptySeo = {
  siteName:    "",
  title:       "",
  description: "",
  keywords:    "",
  image:       "",
};

// Site-wide SEO defaults, managed from the control panel (/cpanel → SEO tab).
export async function getSeoSettings() {
  try {
    const { seo } = await api.get("/seo", { auth: true });
    return seo || null;
  } catch {
    return null;
  }
}

export async function updateSeoSettings(seo) {
  const { seo: saved } = await api.put("/seo", seo, { auth: true });
  return saved;
}
